require("./toaster.js");
require("./toaster.css");
module.exports = "toaster";



//////////////////
// WEBPACK FOOTER
// ./~/angularjs-toaster/index.js
// module id = 91
// module chunks = 0